import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const LogoModal = ({ isOpen, onClose, watchlist, logos, selection, onSave, fetchAssociatedLogos }) => {
  const [typology, setTypology] = useState(selection?.typology || '');
  const [logoId, setLogoId] = useState('');
  const [logoIds, setLogoIds] = useState(selection?.logoIds || []);


  useEffect(() => {
    if (!isOpen) {
      setTypology('');
      setLogoId('');
      setLogoIds([]);
    }
  }, [isOpen]);

  useEffect(() => {
    const loadAssociatedLogos = async () => {
      if (isOpen && watchlist) {
        try {
          const data = await fetchAssociatedLogos(watchlist.id);
          if (data) {
            const the_data = data.data.results.map((r)=>r.id)
            //setTypology(data.typology || '');
            setLogoIds(the_data || []);
          }
        } catch (error) {
          console.error('Failed to fetch associated logos:', error);
        }
      }
    };

    loadAssociatedLogos();
  }, [isOpen, watchlist]);


  const filteredLogos = logos.filter(logo => logo.typology === typology);

  const handleAddLogo = () => {
    if (logoId && !logoIds.includes(logoId)) {
      setLogoIds([...logoIds, logoId]);
      setLogoId('');
    }
  };

  const handleRemoveLogo = (idToRemove) => {
    setLogoIds(logoIds.filter(id => id !== idToRemove));
  };

  const handleSave = () => {
    if (watchlist) {
      onSave(watchlist.id,  logoIds );
      toast.success("Assegnazione logo avvenuta con successo.");

    }
    onClose();
  };

  const getLogoPath = (logo) => {
     if(logo.typology==='flag'){
        return process.env.REACT_APP_LOGO_URL + 'flags/'+(logo.iso.toLowerCase())+'.png';
     }
     if(logo.typology==='blazon'){
        return process.env.REACT_APP_LOGO_URL + 'blazons/'+(logo.iso.toLowerCase())+'.png';
     }
  }

  if (!isOpen || !watchlist) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container-big">
        <div className="modal-header">
          <h2 className="modal-title-document">Assegna loghi e simboli</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content-large">
          <div className="modal-body">
            <div className="modal-update-subtitle">{watchlist?.name}</div>
            <div className="" style={{marginBottom:"20px"}}>
              Scegli di aggiungere uno stemma o una bandiera a questa squadra.
            </div>

            <div className="space-y-4 mt-4">


                <div>
                  <div className="">
                    {['blazon', 'flag'].map(option => (
                      <label key={option} className="radio-label" style={{marginBottom:"15px"}}>
                        <input
                          type="radio"
                          name="tipologia"
                          value={option}
                          checked={typology === option}
                          onChange={() => setTypology(option)}
                        />
                        <span className="custom-radio" />
                        {option==='flag' ? 'Bandiera' : 'Stemma'}
                      </label>
                    ))}
                  </div>
                </div>


              <div style={{marginTop: "20px"}}>
                <select
                  className="border p-2 rounded w-full fancy-select"
                  value={logoId}
                  onChange={(e) => setLogoId(e.target.value)}
                >
                  <option value="">Seleziona un logo</option>
                  {filteredLogos.map((logo) => (
                    <option key={logo.id} value={logo.id}>{logo.name}</option>
                  ))}
                </select>

                <button
                  className="fancy-button"
                  onClick={handleAddLogo}
                  disabled={!logoId}
                >
                  Aggiungi
                </button>

              </div>

              <div className="flex items-center gap-2">


              </div>



              {logoIds.length > 0 && (
                <div style={{display:"flex", flexDirection:"row", gap:"30px", marginTop:"30px"}}>
                  {logoIds.map((id) => {


                    const logo = logos.find(l => parseInt(l.id,10) === parseInt(id,10));
                    return (
                      <div key={id} className="flag_outer">
                        {logo && (
                          <img
                            src={getLogoPath(logo)}
                            alt={logo.name}
                            className="flag_preview"
                          />
                        )}
                        <div className="logo_name">
                          {logo.name}
                        </div>
                        <button
                          className="flag_delete"
                          onClick={() => handleRemoveLogo(id)}
                          title="Rimuovi"
                        >
                          Elimina
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="footer-btn btn-secondary" style={{width:"140px"}} onClick={handleSave}>indietro</button>
          <button className="footer-btn btn-primary" style={{width:"190px"}} onClick={handleSave}>Salva Modifiche</button>
        </div>
      </div>
    </div>
  );
};

export default LogoModal;
